import React from 'react';
import { Route, Navigate, Outlet } from 'react-router-dom';

import { useSelector, useDispatch } from 'react-redux';
import { userSelect } from '../redux/selectors/index';

  

// handle the private routes
function UnverifiedMailRoute({children}) {
  const users = useSelector(userSelect);
  let to = '/verify-user'

  const userLoginIsValid = ((users?.emailVerification ?? 0) == 1) && ((users?.phoneVerification ?? 0) == 1)


  
  if (!userLoginIsValid) {
    return <Navigate to={to} replace />;
  }

  if ((users?.fee ?? 0) == 1) {
    return <Navigate to={'/'} replace />;
  }


  return children ? children : <Outlet />;  

}

export default UnverifiedMailRoute;